import { Tab, Button } from '@material-ui/core';
import { Description, Group, Settings } from '@material-ui/icons';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { getInfosDashboard, getTeams, getDefaultTeamMembersByBusiness } from '@webapps/business';
import { useAuth, useQuery, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useState } from 'react';
import TeamBusiness from './Team';
import BusinessContract from './BusinessContract';
import TeamIcon from 'components/Icons/Team';
import KPIBusiness from 'pages/Business/AnnoncesCandidats/components/KPIBusiness';
import CvTheque from 'components/Icons/CvTheque';

const Team = () => {
  const {
    classes,
    css,
    global,
    theme: { spacing, fontSizes },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const [value, setValue] = useState('1');

  const {
    data: dashboardInfo = {},
    refetch: refetchDashboardInfo,
  } = useQuery(getInfosDashboard, {
    key: 'infoDashboardBusinessa',
    variables: { id: idUser },
  });

  const kpiData = [
    { label: 'Étudiants', value: dashboardInfo?.teamStats?.totalStudents, icon: Group },
    { label: 'Contrats de stage', value: dashboardInfo?.teamStats?.internshipStudents, icon: Description },
    { label: 'Contrats d\'alternance', value: dashboardInfo?.teamStats?.alternanceStudents, icon: Description },
    { label: 'Contrats à signer', value: dashboardInfo?.contractStats?.contractToSign, icon: CvTheque },
  ];


  return (
    <div className={global.container}>
      <KPIBusiness data={kpiData} />
      <TabContext value={value}>
        <TabList className={classes.tabContainer} indicatorColor="default" onChange={(e, v) => setValue(v)} >
          <Tab className={[global.mainTitle, global.tab, value === '1' && global.activeTab]} label="Equipes" value="1"/>
          <Tab className={[global.mainTitle, global.tab, value === '2' && global.activeTab]} label="Réglages contrats" value="2"/>
        </TabList>
        <TabPanel className={global.tabPanel} value="1" >
          <TeamBusiness />
        </TabPanel>
        <TabPanel className={global.tabPanel} value="2" >
          <BusinessContract />
        </TabPanel>
      </TabContext>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({

});

export default Team;
